var _defs, _path, _text, _text2, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@font-face{font-family:\"Raleway-SemiBold\";src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"); font-weight:600;font-style:normal;} @font-face{font-family:\"Raleway-Bold\";src:url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAABDEAA8AAAAAG3QABAapAAAAAAAAAAAAAAAAAAAAAAAAAABHUE9TAAABWAAAAIkAAADGjtqWoU9TLzIAAAHkAAAATQAAAGBkySycY21hcAAAAjQAAABZAAABYgDaCOpjdnQgAAACkAAAAE4AAACKFKACuWZwZ20AAALgAAAIHgAAD5TiGZ5aZ2FzcAAACwAAAAAIAAAACAAAABBnbHlmAAALCAAAAfcAAAJMpTUM0mhlYWQAAA0AAAAANgAAADYZpBzhaGhlYQAADTgAAAAaAAAAJAOuAsBobXR4AAANVAAAABgAAAAYDfMAsmxvY2EAAA1sAAAADgAAAA4CHgGwbWF4cAAADXwAAAAgAAAAIAKrD/5uYW1lAAANnAAAAcYAAAMVdS+OiXBvc3QAAA9kAAAAFAAAACD/nwA4cHJlcAAAD3gAAAFMAAABnE8owwJ4nGNgZGBg4GLQYrBgYHZx8wlhEEmuLMphEMlJLMljEGFgAcoy/P/PAFLFmJ1alMfAAWKBMQsDE5DHxJAB1M8E1A9SG8DgBKRZGaDg/1w4azGctRyIz/2f+38VkMMENIcRrBNCszAwQ8UYwWxGqBo+sBomBhkGMSAPJMIKUvP/MYj1/zEAEt0YjwAAAHicY2BhCmbaw8DKwMDUxRTBwMDgDaEZ4xiMGM0ZkMACBqb/Akh8P38/V6CgAkMu85r/YgwMLE0MrxQYGKeD5JjYmY4BKQUGZgBIhQzrAAAAeJxjYGBgZoBgGQZGBhCIAfIYwXwWBgcgzcPAwcAEZCswhDAkMqQy5P7/DxRF4v1/+n/t/4X/5/2fDjUBDhjZGAgCVsJKMACKNUxQ94MACxmG0RgAAAiYEMIAAAB4nGO6xcDFdIyBlcmaQZCJnYGDgeH/byD+BsL/tf9/A8pxQfgMIkRBdSAWRBERA/P54eIgUpxBlUGDSYaBlXHJ/9WMexm9GJcAAPe9FV0AAHicjVdbb9zGFR5Se99VsDYC1wDVdogpiQCUgr4UkFUjIbTatS6NvdKuHVK2U3IvkpUmsdOL5bRRq7h1bUwfC7Tpb+jL0HlZ96l+yI/pr1C/M8NdXeAGJYbkzDlnzjlzbjMTbv7j67//7fmfn/3pj0+/Ov7D74++/N1vv3hy+Pg3v/7VLz9/9PCzTz/5xccHD/b3xqPhIE1+/tH9e3d34+jDO7f7ve3urZsf/Gxrc2P9RuedHzZr1UUrq9daojWuLS2yrFZHt760aKlSS5U1UN0KuAq3I3drJ2qvOa4bO8JVoSp4bXrTkRxOETFYYBbmgsVWT2xt70a8LRONBKR/bmTwyzNc3lN2qx+pToDRmfENPZ4N1y+gN6ZowRXrSjnK2JwHeOhklu4UW3+JsZJYqEEgXBGNQZtVWMPtJy30GtOexW+AI5802QDv8EMxsfLebqR4shevg5rZntKtN2E/EU9MP1F8yLkqeWLQjaSrrEQ4+XgngsWs1JGucHkcT05eLxC1cMHLZquZsF5sZ6H1orcbQZTiL/rRS9uyW8lqnP0IuGjCmQo11CYoAWnAacC2LHjmpV3R9M4kZOpYYwsaoMdDrELDDNGrkFlsOLENrGkE+SQIGBuYgsGEU+oCYBUDOzbU7+TUFWCahHnFbIspjTQPrATPhLViWAmrYcOet+ELAr0E5F8WY1WLfdOw5i0nA88dDZ5Yx1k1dCaa005OeQxKgh3PYNCcyM4wgjyz8NunK7i9G33TYOCvv6BYpWdpsZ3ZNwNxGtbbEbzXzqybQYLQpuGc1+YIaxX2IqJNHMQ8onttaZGii0di7Ig4e/tt+aidNZutLdlCICPWdIBlaclPAmlCjgJNNFcQpnPexlB0EpAIpA3aBkDDOzxRgyRAlzc7skNRkRI1u5LZc15mFTzrPfYe7FZqqJoYr6q6WJ1h3mfvG0yJMGWxqqwrxupt0eZXD+RQDBCBYTfad/biFLxVKFJVEKtOVmCryJerFpbUztjNAGvbQgzeCrp3kaRkDC7lGs/Cgp8OUxqvuch7maPE2lp8ZkabSxWmwwQU7VgTIxMBbIuUj2BlLBeW6wl0d3dpTn83ko2RGAlYOAxlimU7fBg7Mh5qi2M+VGNLi8XT6pQXJ5ty3hvu4YO0GCRiYACUnRdh+xcBe6A6CxObJE7/Lf2Xm6I9AgW96UjNIeJcPopNyLCurhv/k8g6Q8ThU81cNn86HVn5CAM0qfbPDx/Mhh16E1jtXRMrquBT5EWu+thRn8TBjCRVxwMueVOsCProyTfoTVQRneNhSsWpRLEHwCYAPBoglsGwk8hpxGFawZ9JUp8F51iipFp9iLY9Wo467vIk5kkCKLLHdbgq4s/3UgouKrtds54uaj9+qexhLqMEclQZO8BeOhYuqrWipDXWJx0L0I71IsUcKYVUFlT0OiAGe1+V/A36oT0KRDqGE0keT8d6bgfqausQN6ct3BgktqdtCcOhWgzoM5SIRnUf2Vb0LsnLkl+TqFr3UXAL/vBOgm2BN3mHa1eniGQywgaNYjAyhFWPCDFfN199GmT3y94pRLeHgSGuaK7QbCdS3SlJWTd0Pg+U/b1lIGnx1g7qR0E7ioxX9DZg3hBR5dBsrux+lLtHz9+gqc7UYWYaILrs0rboTvWtG32N0JJuDd2qnqp4cLQqQAeDLtNyToMAfSht5sxpdc0C0IconmP0QpJ8UPDGek1mO+RUPnFQSAW9zuTk313UyETQG8ckvqIF0QzNWhrGZK4SId9kilySaXVqG3oJZ8E13cpaZ8KZJRXPGz63HrTKLefmD8UMrfJ5npV53o0d9SAORmZWKa/gHBUVlXu4rU8bd5ENwi2jjmH5yCquegE2Eb2258aqm6Y6UFRaHcE6iKG8w64wxcS6RR+G1BLrysZw1hMvbWZVxDL9qmI5s60yqj0Vo+Z8A4VeDpOR2ahhZbbsXKejUUk7uqp9+5hKUz8qOoVYh4yvDoM8is33cTDDH1JOlqeWrBBOzpBFze7QxIaffx8HlTfOkpX/T1gl96aqahxVI7/y3aLmjIM2jbs2bcN509SJTcppKam0Zfffogxt+JcAvwzVrkHJa7mWsM2XUKVLoisaoodItzKpY9zm1YFogva1Ce06kE1o89oxVGiTkxOtt6E2RoDeNc/EeY7OZ5voPAxi9Dr0JiDp0JtnUj3P0saFqp+zNz6tnkeKGTPa6MWMI40yq4EzcMEpQqLPmzDXiranD1UxliuZVfZzgiIR2N6KlPVp/afy/4qxkOnDJYvlRYA6gj/g6/k3YyoXofManHt5fvYnYJ4OtZaqt+j8QntTlQLgXfj36Nu85ujjxBnDaBCl4lnoVbJ9eVoSHgbTuVO77emUzudegPajI0DJUt/STqIs/Iu+S69DptPSKMYfBvlB94i8+1SzexpwfoBzVsvCaQsb5QFtVZyoK74uchIHnoM01XVIX2Ou4iy1Q6dj3ABEk1vX2XVzGRL5PQN7QMGLrjvXYtwrJif/WYhNqbKxyePtS86bl4CS/DIuGuqZNm+OExqGXbzk51S0gmdITkNH2jdsudWDEehGVlt2anTLm16wvg6+C81pPqrUhD0QT1yyxYR9JL7AcaElFOf3UBSx1U/YBwuxlNhSpaDb1J3IfAlpTdiPF+h8QGeZGf33F3BXOwtoLFDgpZOTfy7QxelU7lczuYeQSz05FTxh+28USyFn3TWBh6bXMmHYjYVRpODnsuU9uYvrIpA/IPG5PjR+ayHWXKDQX0mh/wK/JnnXAAAAAQAB//8AD3icVZFPbtNAFMZnxnHc2qmjcWynLrET/w8diJM4ceo4SZO2IkAUWCAQm0hUoAgUVarMqkC3SJyBA3AAjoDEEg7RO7AjMHFZlDfSzBtp5tP3+x4ANwoCEQC0QN8BB0rjbciyeZQyWykgpI3DZgvamK6uiRZXn67QYzT//RXNL+gXoP35hQykAB8cADJWzShyglxOcoRU2+NTsVgUJI7KtKkMaRMpDkIcbhR7nREM22q52/FsK8/52U2HslpWRGhbXgA3RwO6IziEDdrmFdmgbyItXh6ZJ1rSJ48I6ZwNzi+LWNL5+m2WsZbdzpMA3hPE3QOtc6zu60b/czjf54VKOzL055Z1/vqLIqEzJufs3brTJDO5sMt3eeGuKztqGWx4KpTniPJUgAvMMWZ1/Q2GGANrm0sVIGxQaCRxsAiluNlirQbqZiQGVOQ8ZxqIWuyVRcSYDWRbIoTNw+V9//jy6bN3EwTXq5w/tOvTnbel6YtvUMq5A9dJXJ7MTqPZh9ns/bSgbdUHVb9Wq49s2K8npplk8xkCwKyoLwe4Y5mtVnFFZUqixqVyPuVhic8yptOSynGWr2vj62TxjSZUrkPPDCOFWX0knj8t/tsvjFeTyQO+9nLUGlo7AHqjZNha/4TeYX/QWv9AhdOwNw6i2E4eeuC/+gslpF1yAAABAAAABAaps6OlcF8PPPUICwPoAAAAANPcXiMAAAAA2yt0dgAO//YDawLGAAEABgACAAAAAAAAeJxjYGRgYF7zXwxILmaAAEYGVMAGAEYrAnMAAAJgADICawAOAj4AGQJXABwDowA9APAAAAAAAAYAIgCKANYBIAEmAAAAAQAAAAYAOQACAAAAAAACABAALwCaAAAB+A+UAAAAAHicdZDNTttAFIXPJIFSqY26K6KbUVYggWOiiAXZ8COyQgmKEHsrGdmmdsaaGYjyAt11020XXbDkOVp1y2PwFpxxhgqQams83xzfc+feC+AT/kBg9cy4VizwjqcVN9DC18BNfIYO3MIHfAu8ho/4EXid+q/AbWzhni7Res/TX/wOLNAW3wM3sCF+Bm4iEneBW9gUD4HXsCUeA69js9EM3Ea/8eVUV0uTp5mTvXg/lpeZkpOkUItkKS+MvlZTJ49vXKaNldt5WSVFkZj8KC2TvIimutzZlYvcZXKirDK3aiaHeu7kKCmV7IQ8nSjAiS5m/SjuHQxG49HZIKh7Xn6+0vOVMjbXc1mHvgzKnKsOu107NXnlbGRZgTZpdzw8xykHW2EJgxwpMjhI9BBjn0vikoriPkGCgrTgvuT5gvEa11SmteMYN9wzagaW521mK5nXuwp+ffYj5i/JOZWIPs3TDnYZvaDm3f4eRb9i/C2/MypDxs3rO0b0lnU1nTf1dJjvtXJCV0F/n39i9nOAAf1jrjPS69i9f9Fvu3zWr+qKLKv0tcgXWf+Xyc/Rsf9DdPladusnUFGz9NowAz+tlP/H7PL8CTFylVsAAHicY2BmAIP/cxiMGDABGwAqiQHXeJxNiElOQkEQQPv3h2YQATEyQzEK2o44T/CDy14oYic0LNhwABMOwMqEDYQbsGT7ccWOo3gPXJR8iIaq5L1XZfxULsuy7GfyqYjwWFzAQ2EC9wWEu6Vv9xFu8gjX+Qlc5RAucx24yCKUshM4zyzgLINwmkY4SSEcA8JREoEnEA4TEziII6RjCKkoAkQQkmGERAghHkSIGRFshY0gtqJWhazaiyzZ3BUBuSP8MqD8alt4pF3YpEfZlK/klVvCLR2CSa1EpFd9eDW3YgpYhbVZj43ZnH0zZE6igFTIC2mTMbG7Ok6pd6h0Kqp8FGib9uic2v1ENwy7NtNG5jsXMwe+CdP12jK1vpmvWzRqTZP1TSKbrcZU04bqczAgiaowR/XGl06WqaaUPtcaU5s+VNUu4YRzvtSqutbB+fq5praxhG/gL1f9b2vCv2CSaPw=) format(\"woff\"); font-weight:bold;font-style:normal;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h150.513v110.265H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5e00ff",
    d: "M0 0h160v160H0z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Raleway-Bold, Raleway",
    fontWeight: 700,
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48.489,
    y: 143.872
  }, "Team"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#c01fff",
    fontSize: 19,
    fontFamily: "Raleway-SemiBold, Raleway",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 115.998,
    y: 136.371
  }, "4"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.489 155.433h59.494",
    fill: "none",
    stroke: "#c000ff",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.487 8.105)",
    clipPath: "url(#A)",
    fill: "#c000ff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 24,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 44,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 84,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 104,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 104,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp02);
export default __webpack_public_path__ + "static/media/scrumlr-lp-02.a0d6211d54a5eb42d645ddf1b2e2a0b6.svg";
export { ForwardRef as ReactComponent };